import { render } from "./KycAddressFields.vue?vue&type=template&id=b53bc564&scoped=true"
import script from "./KycAddressFields.vue?vue&type=script&lang=js"
export * from "./KycAddressFields.vue?vue&type=script&lang=js"

import "./KycAddressFields.vue?vue&type=style&index=0&id=b53bc564&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b53bc564"]])

export default __exports__